import type { ColorTag } from './api';

/**
 * Per-project color identity per ARCH §9.
 *
 * PLACEHOLDER VALUES — final hex tuning is D-OPEN-1 ("Final hex values for
 * the seven-color palette") and lives in the visual design pass during
 * Build E. Picked here so the 4px / 12px / dot affordances render visibly
 * against the cream surface (--color-bg #ede5d3) and the navy chrome
 * (#1c2638) without being mistaken for the orange brand accent (#e85d04).
 *
 * Do not promote these to "locked." If you find yourself using these to
 * make other design decisions, stop and surface to the visual pass first.
 */
export const COLOR_HEX: Record<ColorTag, string> = {
  amber: '#d97706',
  sage: '#87a96b',
  rust: '#b54f3a',
  teal: '#0e7c86',
  slate: '#64748b',
  plum: '#7c3a8b',
  wheat: '#c9a64b',
};

export function colorHexFor(tag: ColorTag | null | undefined): string {
  if (!tag) return COLOR_HEX.amber;
  return COLOR_HEX[tag] ?? COLOR_HEX.amber;
}
